import { useCartState, useHydrateCartState } from '@ecomm/data-cart'
import { useRestoreCart } from '@ecomm/data-cart/actions/useRestoreCart'
import { IOGetCart } from '@simplisafe/ss-ecomm-data/cart'
import { selectCartId } from '@simplisafe/ss-ecomm-data/redux/select'
import { type FC, type ReactElement, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

type InitializeStoreProps = {
  readonly children: ReactElement
  readonly enableJotai: boolean
}

export const InitializeStore: FC<InitializeStoreProps> = ({
  children,
  enableJotai
}: InitializeStoreProps) => {
  const dispatch = useDispatch()
  const restoreCart = useRestoreCart()
  const reduxCartId = useSelector(selectCartId)
  const jotaiState = useCartState()

  useHydrateCartState()

  useEffect(() => {
    !enableJotai && reduxCartId.isNone() && dispatch(IOGetCart())

    const fetchStates = ['not_initialized', 'no_cart_id']
    enableJotai && fetchStates.includes(jotaiState) && restoreCart()
  }, [enableJotai])

  return <>{children}</>
}
